export default "__VITE_ASSET__BRkHw1pU__"